module.exports = __webpack_public_path__ + "img/thumb-vis-met-romige-citroensaus.5fbc038c.jpeg";